import React, { useRef, useEffect } from 'react';
import { Box, Divider } from '@chakra-ui/react';
import PageSetup from './PageSetup.js';
import { t } from '../utils/i18n.js';

var _a;
var PageType;
(function (PageType) {
    PageType["PRE_PURCHASE_PRODUCT_PAGE"] = "PRE_PURCHASE_PRODUCT_PAGE";
    PageType["PRE_PURCHASE_ADD_TO_CART_CLICK"] = "PRE_PURCHASE_ADD_TO_CART_CLICK";
    PageType["PRE_PURCHASE_CART_PAGE"] = "PRE_PURCHASE_CART_PAGE";
    PageType["PRE_PURCHASE_CART_DRAWER_PAGE"] = "PRE_PURCHASE_CART_DRAWER_PAGE";
    PageType["PRE_PURCHASE_CHECKOUT_CLICK"] = "PRE_PURCHASE_CHECKOUT_CLICK";
    PageType["CHECKOUT"] = "CHECKOUT";
    PageType["POST_PURCHASE_PAGE1"] = "POST_PURCHASE_PAGE1";
    PageType["THANK_YOU_PAGE"] = "THANK_YOU_PAGE";
    PageType["ORDER_STATUS_PAGE"] = "ORDER_STATUS_PAGE";
})(PageType || (PageType = {}));
var PageNames = (_a = {},
    _a[PageType.PRE_PURCHASE_PRODUCT_PAGE] = "Product page",
    _a[PageType.PRE_PURCHASE_ADD_TO_CART_CLICK] = "Add to cart click",
    _a[PageType.PRE_PURCHASE_CART_PAGE] = "Cart page",
    _a[PageType.PRE_PURCHASE_CART_DRAWER_PAGE] = "Cart drawer page",
    _a[PageType.PRE_PURCHASE_CHECKOUT_CLICK] = "Checkout click",
    _a[PageType.CHECKOUT] = "Checkout",
    _a[PageType.POST_PURCHASE_PAGE1] = "Post purchase page",
    _a[PageType.THANK_YOU_PAGE] = "Thank you page",
    _a[PageType.ORDER_STATUS_PAGE] = "Order status page",
    _a);
var QuickSlotSetupModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onGoToEditor = _a.onGoToEditor, activePage = _a.activePage, continueButton = _a.continueButton, checkStatusButton = _a.checkStatusButton, widgetType = _a.widgetType, editorRedirectionConfig = _a.editorRedirectionConfig, slotStatus = _a.slotStatus, onContactSupport = _a.onContactSupport, slotNumber = _a.slotNumber, secondaryButtonLabel = _a.secondaryButtonLabel, _b = _a.direction, direction = _b === void 0 ? "ltr" : _b, _c = _a.isMobileView, isMobileView = _c === void 0 ? false : _c;
    var modalRef = useRef(null);
    // Inject RTL styles for modal positioning
    useEffect(function () {
        var styleId = "quick-slot-setup-modal-rtl-styles";
        var styleElement = document.getElementById(styleId);
        if (direction === "rtl") {
            if (!styleElement) {
                styleElement = document.createElement("style");
                styleElement.id = styleId;
                document.head.appendChild(styleElement);
            }
            styleElement.textContent = "\n        #quick-slot-setup-modal {\n          --s-modal-translate-x: 50% !important;\n        }\n      ";
        }
        else if (styleElement) {
            styleElement.remove();
        }
        return function () {
            var el = document.getElementById(styleId);
            if (el)
                el.remove();
        };
    }, [direction]);
    useEffect(function () {
        var _a, _b, _c, _d;
        var modal = modalRef.current;
        if (!modal)
            return;
        if (isOpen) {
            (_b = (_a = modal).showOverlay) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else {
            (_d = (_c = modal).hideOverlay) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    }, [isOpen]);
    useEffect(function () {
        var modal = modalRef.current;
        if (!modal)
            return;
        var handleHide = function () {
            onClose();
        };
        modal.addEventListener("hide", handleHide);
        return function () { return modal.removeEventListener("hide", handleHide); };
    }, [onClose]);
    var pageTitle = widgetType === "QUANTITY_BREAKS"
        ? t("Add Quantity Breaks to your product page")
        : activePage
            ? t("Add Upsell.com to your ") +
                t(PageNames[activePage])
            : "";
    return (React.createElement("s-modal", { id: "quick-slot-setup-modal", heading: pageTitle, size: "large", padding: "none", ref: modalRef, dir: direction },
        React.createElement(Box, { p: 0, m: 0, dir: direction },
            React.createElement(Divider, null),
            React.createElement(Box, { py: "12px", px: "24px" }, activePage && (React.createElement(PageSetup, { pageType: activePage, onGoToPage: onGoToEditor, checkStatusButton: checkStatusButton, widgetType: widgetType, editorRedirectionConfig: editorRedirectionConfig, slotStatus: slotStatus, onContactSupport: onContactSupport, slotNumber: slotNumber, direction: direction, isMobileView: isMobileView })))),
        React.createElement("s-button", { slot: "secondary-actions", variant: "secondary", commandFor: "quick-slot-setup-modal", command: "--hide", onClick: onClose }, secondaryButtonLabel || t("I’ll do it later")),
        React.createElement("s-button", { slot: "primary-action", variant: "primary", onClick: continueButton === null || continueButton === void 0 ? void 0 : continueButton.onClick, loading: continueButton === null || continueButton === void 0 ? void 0 : continueButton.isLoading, disabled: continueButton === null || continueButton === void 0 ? void 0 : continueButton.isDisabled }, (continueButton === null || continueButton === void 0 ? void 0 : continueButton.label) || t("Continue"))));
};

export { PageNames, PageType, QuickSlotSetupModal as default };
//# sourceMappingURL=QuickSlotSetupModal.js.map
